import { createSlice } from "@reduxjs/toolkit";
import { dateTFormat } from "../utility/Utility";

const initialState = {
  selectedOrder: null,
  orderDate: dateTFormat(new Date()),
  orderEndDate: dateTFormat(new Date()),
  rowsPerPage: 10,
  orderCreatedBy: "All",
  cartName: "",
  agentSourceFilter: {
    value: "all",
    label: "All",
    type: "all",
  },
};

export const inAppCartOrderSlice = createSlice({
  name: "inAppCartOrder",
  initialState,
  reducers: {
    setInAppCartSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    clearInAppCartSelectedOrder: (state) => {
      state.selectedOrder = null;
    },
    setInAppCartOrderCreatedBy: (state, action) => {
      state.orderCreatedBy = action.payload;
    },
    clearInAppCartOrderCreatedBy: (state) => {
      state.orderCreatedBy = "All";
    },
    setInAppCartCartName: (state, action) => {
      state.cartName = action.payload;
    },
    clearInAppCartCartName: (state) => {
      state.cartName = "";
    },
    setInAppCartAgentSourceFilter: (state, action) => {
      state.agentSourceFilter = action.payload;
    },
    clearInAppCartAgentSourceFilter: (state) => {
      state.agentSourceFilter = {
        value: "all",
        label: "All",
        type: "all",
      };
    },
    setInAppCartOrderDate: (state, action) => {
      state.orderDate = action.payload;
    },
    setInAppCartOrderEndDate: (state, action) => {
      state.orderEndDate = action.payload;
    },
    clearInAppCartOrderDate: (state) => {
      state.orderDate = dateTFormat(new Date());
    },
    clearInAppCartOrderEndDate: (state) => {
      state.orderEndDate = dateTFormat(new Date());
    },
    setInAppCartRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    clearInAppCartRowsPerPage: (state) => {
      state.rowsPerPage = 10;
    },
  },
});

export const {
  setInAppCartSelectedOrder,
  clearInAppCartSelectedOrder,
  setInAppCartOrderCreatedBy,
  clearInAppCartOrderCreatedBy,
  setInAppCartCartName,
  clearInAppCartCartName,
  setInAppCartAgentSourceFilter,
  clearInAppCartAgentSourceFilter,
  setInAppCartOrderDate,
  setInAppCartOrderEndDate,
  clearInAppCartOrderDate,
  clearInAppCartOrderEndDate,
  setInAppCartRowsPerPage,
  clearInAppCartRowsPerPage,
} = inAppCartOrderSlice.actions;

export default inAppCartOrderSlice.reducer;